/*
 * Hypowered motion system
 * One-shot reveals via IntersectionObserver.
 * Respects prefers-reduced-motion.
 */
(function () {
  if (typeof window === 'undefined') return;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) {
    // Mark everything immediately so nothing stays hidden if CSS guards fail.
    document.querySelectorAll('[data-motion="fade-up"], [data-motion-stagger]').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  if (!('IntersectionObserver' in window)) {
    // Fallback: just reveal everything.
    document.querySelectorAll('[data-motion="fade-up"], [data-motion-stagger]').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      el.classList.add('is-visible');
      observer.unobserve(el); // one-shot per protocol
    });
  }, {
    root: null,
    rootMargin: '0px 0px -10% 0px', // trigger slightly before fully in view
    threshold: 0.12
  });

  function observeAll(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-motion="fade-up"]:not(.is-visible)').forEach(function (el) {
      observer.observe(el);
    });
    root.querySelectorAll('[data-motion-stagger]:not(.is-visible)').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { observeAll(); });
  } else {
    observeAll();
  }

  // Re-scan when a section is reloaded in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    observeAll(e.target);
  });
})();
